var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{ref:"msgbox",staticClass:"ui-loading-wrap"},[_c('div',{staticClass:"ui-loading-spinner"},[_c('i',{staticClass:"iconfont iconLoading"}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.msg))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }